module.exports = __webpack_public_path__ + "img/collect_icon_06.0782b0b1.png";